import axios from 'axios';
import { SYSTEMDOX_API_URL } from '@/lib/apiConfig';

const api = axios.create({ baseURL: SYSTEMDOX_API_URL });

export interface Issue {
  number: number;
  title: string;
  state: string;
  url: string;
  labels: string[];
  assignee: string | null;
  created_at: string;
}

export interface CreateIssuesResult {
  draftId: string;
  issuesCreated: number;
  issues: { number: number; title: string; url: string }[];
}

export const issuesApi = {
  setAuthProvider(getToken: () => Promise<string | null>) {
    api.interceptors.request.use(async (config) => {
      const token = await getToken();
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    });
  },

  async createFromSpec(draftId: string, repoFullName?: string): Promise<CreateIssuesResult> {
    const { data } = await api.post(`/specs/${draftId}/create-issues`, { repoFullName });
    return data;
  },

  async listIssues(repo: string): Promise<Issue[]> {
    const { data } = await api.get('/issues', { params: { repo } });
    return data;
  },
};
